import "./legacy_portico_bundle.ts";
import "../templates.ts";
import "../inputs.ts";
import "../portico/showroom.ts";

// Import styles in the required order
import "../../styles/portico/showroom.css";
import "../../styles/app_variables.css";
import "../../styles/buttons.css";
import "../../styles/inputs.css";
import "../../styles/banners.css";
import "../../styles/app_components.css";
